module.exports = __webpack_public_path__ + "img/img_ai_test_stock_bg@3x.17f46be1.png";